module.exports = __webpack_public_path__ + "img/sap.598a3ddd.svg";